<template>
    <div class="deal_refund_box">
        <!-- BOX-go -->
        <div>
            <!-- 内容-spanTitle -->
            <div class="deal_content_box">
                <div class="deal_content_title">{{spanTitle}}</div>
                <div class="deal_content">
                    <div class="content_auto_box">
                        <div class="remind_box">
                            <i class="el-icon-warning icon_warning"></i>
                            請在新打開的付款頁面完成{{spanTitle}}，付款完成前請不要關閉該視窗。
                        </div>
                        <div>
                            <el-button type="primary" class="button_input" @click="funClick()">{{spanTitle}}成功</el-button>
                            <span class="button_span">{{spanTitle}}遇到問題？</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- BOX-end -->
        </div>
        <!-- deal_refund_box -->
    </div>
</template>

<script>
export default {
    name: 'LoginTransfer',
    props:[
        'spanTitle'
    ],
    data() {
        return {
        }
    },
    methods: {
        funClick(){
            this.$emit("transferShowFun");
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*  */
    .icon_warning {
        font-size: 22px;
        color: #ff4a05;
        padding: 0 6px 0 24px;
    }
    .input_box {
        width: 100px;
    }
    .textarea_box {
        width: 350px;
        margin-left: 10px;
    }
    .input_pass {
        width: 350px;
    }
    .input_pass_number {
        margin-left: 10px;
        color: #4d80e7;
    }
    .el-input__inner {
        height: 20px;
    }
    .deal_refund_box {
        margin: 0px;
        font-size: 15px;
        color: black;
    }
    .deal_title {
        display: flex;
        justify-content: flex-start;
        font-weight: 700;
    }
    .deal_title span {
        margin-left: 15px;
        margin-right: 8px;
    }
    .deal_title .deal_hr {
        flex: 1;
        margin-left: 18px;
    }
    .deal_title .deal_hr .cut_off {
        height: 3px;
        background: black;
        margin-top: 8px;
    }
/* 内容 */
    .remind_box {
        background: #fff4cc;
        color: black;
        width: 70%;
        min-width: 686px;
        height: 50px;
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        margin-left: -6px;
    }
    .datetime_box > span {
        margin: 10px;
    }
    .deal_content_box {
        font-size: 13px;
        margin-top: 20px;
        min-width: 800px;
    }
    .deal_content_title {
        height: 42px;
        background: #666666;
        line-height: 42px;
        color: white;
        padding-left: 14px;
        font-weight: 700;
    }
    .deal_content {
        box-sizing: border-box;
        border: 1px solid #666666;
        background: #ffffff;
        color: #777777;
        padding: 5px 25px 30px 25px;
    }
    .content_auto_box {
        padding: 32px; 
    }
    .content_title {
        color: black;
        font-size: 15px;
        font-weight: bold;
        padding-left: 8px;
        padding-right: 50px;
        line-height: 17px;
        border-left: 8px solid #e73262; 
        margin-bottom: 22px;
    }
    .content_title_2 {
        color: black;
        font-size: 15px;
        font-weight: bold;
        padding-left: 8px;
        padding-right: 50px;
        line-height: 17px;
        border-left: 8px solid #e73262; 
        margin: 24px 0 22px 0;
    }
    .content_title_p {
        width: 650px;
        line-height: 21px;
        margin-left: 15px;
    }
    .content_title_button { 
        padding: 4px 8px;
        margin: 26px 0 30px 15px;
    }
    .button_input {
        margin: 0 28px;
    }
    .button_span {
        color: #4d80e7;
    }
</style>
